<section class="page">
  <div class="card">
    <p class="eyebrow">Account</p>
    <h1>Profile</h1>

    @if (supplier(); as s) {
      <div class="kv">
        <div><span>Name</span>{{ s.name }}</div>
        <div><span>Email</span>{{ s.email }}</div>
      </div>
    }

    <div class="actions">
      <a class="primary-link" routerLink="/change-password">Change password</a>
      <button type="button" class="logout-btn" (click)="logout()">Logout</button>
    </div>
  </div>
</section>
